var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_530_7016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8035 11.8124C14.8035 12.6557 15.4871 13.3392 16.3303 13.3392C17.1736 13.3392 17.8571 12.6557 17.8571 11.8124C17.8571 10.9692 17.1736 10.2856 16.3303 10.2856C15.4871 10.2856 14.8035 10.9692 14.8035 11.8124Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51784 11.8124C7.51784 12.6557 8.2014 13.3392 9.04463 13.3392C9.88785 13.3392 10.5714 12.6557 10.5714 11.8124C10.5714 10.9692 9.88785 10.2856 9.04463 10.2856C8.20141 10.2856 7.51784 10.9692 7.51784 11.8124Z",
    fill: "#9B9B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_530_7016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menu-dots.949e95bde32852f0862d8ecd3bb1ebd9.svg";
export { ForwardRef as ReactComponent };